import { render, staticRenderFns } from "./related-posts.vue?vue&type=template&id=17942e5c&"
import script from "./related-posts.vue?vue&type=script&lang=js&"
export * from "./related-posts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17942e5c')) {
      api.createRecord('17942e5c', component.options)
    } else {
      api.reload('17942e5c', component.options)
    }
    module.hot.accept("./related-posts.vue?vue&type=template&id=17942e5c&", function () {
      api.rerender('17942e5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/related-posts.vue"
export default component.exports